// extracted by mini-css-extract-plugin
var _1 = "ArrowIcon__arrow--fuMlT";
var _2 = "ArrowIcon__arrowHoverEffect--yBtRA";
var _3 = "ArrowIcon__circle--yaLpd";
var _4 = "ArrowIcon__degree-90--b4vII";
var _5 = "ArrowIcon__degree0--v_PJw";
var _6 = "ArrowIcon__degree180--seNYl";
var _7 = "ArrowIcon__degree90--TTCuD";
var _8 = "ArrowIcon__hoverableArrow--Dq4zE";
var _9 = "ArrowIcon__main--p2YAH";
export { _1 as "arrow", _2 as "arrowHoverEffect", _3 as "circle", _4 as "degree-90", _5 as "degree0", _6 as "degree180", _7 as "degree90", _8 as "hoverableArrow", _9 as "main" }
